// External packages
import * as React from 'react';

// Components
import { Button } from 'components/Button';
import { Card } from 'components/Card';
import { Icon } from 'components/Icons';

// Modules
import { AddPlaceMapModal } from 'modules/maps/AddPlaceMapModal';
import { PlaceMapsGallery } from 'modules/maps/PlaceMapsGallery';

// Hooks
import { useUploadMedia } from 'api/media';

export default function PlaceMapsPage() {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { mutate: uploadMedia, isPending: isUploading } = useUploadMedia();

  return (
    <Card className="flex flex-col h-full min-h-[calc(100vh-9rem)] md:min-h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between gap-x-8 gap-y-4">
        <h1 className="text-2xl text-gray-600">Mape</h1>
        <AddPlaceMapModal
          isOpen={modalOpen}
          onOpenChange={setModalOpen}
          onSubmit={(data) => {
            uploadMedia(
              { file: data.placeMap, fileType: 'placeMaps' },
              {
                onSuccess: () => {
                  setModalOpen(false);
                },
              }
            );
          }}
          modalTrigger={<Button icon={<Icon name="plus" />}>Dodaj mapu</Button>}
          isPending={isUploading}
        />
      </div>
      <hr className="my-6 h-px text-gray-200" />
      <PlaceMapsGallery />
    </Card>
  );
}
